export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant01-de.d187f6dd.png";